package com.example.readingnotes.domain.model

import kotlinx.datetime.Instant

/**
 * Search history item representing a past user search
 */
data class SearchHistory(
    val id: Int,
    val query: String,
    val filters: SearchFilters? = null,
    val resultsCount: Int? = null,
    val createdAt: Instant,
)

/**
 * Search filters applied to a search query
 */
data class SearchFilters(
    val tags: List<String>? = null,
    val author: String? = null,
    val dateFrom: String? = null,
    val dateTo: String? = null,
    val sortBy: String? = null,
)
